import { render, staticRenderFns } from "./AICsInteractiveHis.vue?vue&type=template&id=991f272e&scoped=true"
import script from "./AICsInteractiveHis.vue?vue&type=script&lang=js"
export * from "./AICsInteractiveHis.vue?vue&type=script&lang=js"
import style0 from "./AICsInteractiveHis.vue?vue&type=style&index=0&id=991f272e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991f272e",
  null
  
)

export default component.exports